import React from "react";
import { IconModeOfTransportCoach, Paragraph } from "@trainline/depot-web";
import * as s from "./LocalAreaTransportAddons.module.css";
const PlusbusCard = ({ label }) => /* @__PURE__ */ React.createElement("section", {
  className: s.container
}, /* @__PURE__ */ React.createElement("div", {
  className: s.icon
}, /* @__PURE__ */ React.createElement(IconModeOfTransportCoach, {
  "aria-label": label
})), /* @__PURE__ */ React.createElement(Paragraph, {
  as: "span",
  typeStyle: "body"
}, label));
var PlusbusCard_default = PlusbusCard;
export {
  PlusbusCard_default as default
};
